import {MutableRefObject} from 'react';

import {isObject} from 'remeda';
import Swiper from 'swiper';

/**
 * Create Swiper component onSwiper event for buttons recreation
 */
export const createOnSwiper =
    (
        navigationNextRef: MutableRefObject<HTMLElement | null>,
        navigationPrevRef: MutableRefObject<HTMLElement | null>,
    ) =>
    (swiper: Swiper) => {
        if (
            swiper?.params?.navigation &&
            swiper?.params?.navigation &&
            isObject(swiper.params.navigation) &&
            'nextEl' in swiper.params.navigation &&
            'prevEl' in swiper.params.navigation
        ) {
            swiper.params.navigation.nextEl = navigationNextRef.current;
            swiper.params.navigation.prevEl = navigationPrevRef.current;
        }

        swiper.navigation.destroy();
        swiper.navigation.init();
    };
